import { EnumBuilder, type ZodInfer } from '@mntn-dev/utility-types'
/**
 * BillingSchedule
 */
export const [BillingSchedules, BillingScheduleSchema, BillingSchedule] =
  EnumBuilder('100_up_front', '50_50')

export type BillingSchedule = ZodInfer<typeof BillingScheduleSchema>
